// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Accordion when component is rendered should render component without errors 1`] = `
<div
  class="accordion"
  data-testid="accordion"
>
  <button
    class="accordionHeader"
    type="button"
  >
    <p
      class="hyphens display18 nomargin brandBlue500 scale"
    >
      test
    </p>
    <img
      alt="Toggle modal"
      src="[object Object]"
      width="20"
    />
  </button>
  <div
    class="accordionContent"
  >
    <div />
  </div>
</div>
`;
